if (window.CONFIG.agenda.gtagId) {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', window.CONFIG.agenda.gtagId);

    loadScript("https://www.googletagmanager.com/gtag/js?id=" + window.CONFIG.agenda.gtagId);
}
